/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


// let addToCartButton = document.querySelector('.product__add-to-cart-button');

// addToCartButton.addEventListener('click', function (e) {
//     jQuery.getJSON('/cart.js', function(cart) {
//        let cartItemsQty = cart.item_count;
//        let cartBagItems = document.querySelector('#cart-qty-items');
//        cartBagItems.innerHTML=cartItemsQty;

//      } );
// });

function handleWhenElementInViewport(options) {
  const threshold = options.threshold ? options.threshold : 0
  const rootMargin = options.margin ? options.margin : "-50% 0% -50% 0%"

  const observerInstance = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (typeof options.callback === "function") {
          options.callback(entry)
        }
      })
    },
    {
      rootMargin,
      threshold,
    }
  )

  observerInstance.observe(options.element)
}

function initRedirectToAccountFromCreateAccont(){
  let redirect = localStorage.getItem('redirect')
  let url = window.location.href

  if (redirect == "account") {
    if(url.includes('register')){
      localStorage.setItem('redirect', 'none');
    }else{
      localStorage.setItem('redirect', 'none');
      document.location.href = '/account'
    }
  }

  $('.js-redirect').on('click', function(e){
    e.preventDefault()
    console.log('clicked');
    localStorage.setItem('redirect', 'account');
    $('#create_customer').submit()
  })
}

initRedirectToAccountFromCreateAccont()

window.addEventListener('load', function(event) {
  var triggers = document.querySelectorAll('[id^="klaviyo-pop"]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      var _klOnsite = window._klOnsite || [];
      _klOnsite.push(['openForm', 'RYFzPV']);
    });
  });
  var triggers = document.querySelectorAll('[href^="#klaviyo-pop-menu"]');
  triggers.forEach(trigger => {
    console.log(trigger);
    trigger.addEventListener('click', function(event) {
      console.log('click');
      event.preventDefault();
      var _klOnsite = window._klOnsite || [];
      _klOnsite.push(['openForm', 'VkBJZk']);
    });
  });
});

class ImgPagination extends HTMLElement {
  constructor() {
    super()
    this.container = document.querySelector(".product-page-container")
    this.images = document.querySelectorAll(".product_media--item [data-media-id]")
    this.bullets = this.querySelectorAll("span")
    this.init()
  }

  init() {
    if (this.images.length < 2) {
      return
    }

    this.handleImages()
    this.handleBullets()
    this.setHeight()

    window.addEventListener("resize", this.setHeight.bind(this))

    handleWhenElementInViewport({
      element: this.container,
      margin: "-75% 0% 0% 0%",
      callback: (entry) => {
        if (entry.isIntersecting) {
          this.classList.add("is-visible")
          this.setAttribute("aria-hidden", false)
        } else {
          this.classList.remove("is-visible")
          this.setAttribute("aria-hidden", true)
        }
      }
    })
  }

  handleImages() {
    this.images.forEach((image) => {
      handleWhenElementInViewport({
        element: image,
        callback: (entry) => {
          const bullet = [...this.bullets].find(
            (bullet) => bullet.dataset.mediaId === image.dataset.mediaId
          )

          if (entry.isIntersecting) {
            bullet.classList.add("active")
          } else {
            bullet.classList.remove("active")
          }
        },
      })
    })
  }

  handleBullets() {
    this.bullets.forEach((bullet) => {
      bullet.addEventListener("click", () => {
        const image = [...this.images].find(
          (imageNode) => bullet.dataset.mediaId === imageNode.dataset.mediaId
        )

        image.scrollIntoView({
          behavior: "smooth",
        })
      })
    })
  }

  setHeight() {
    const image = this.images[0]
    this.style.setProperty("--pagination-position", `${image.clientHeight / 2}px`)
  }
}

customElements.define("img-pagination", ImgPagination)
